import React from 'react';
import { Box } from '@mui/material';
import SaveButton from '../SaveButton';
import UpdateOfferButton from '../UpdateOfferButton';

const OfferSaveActions = ({ onUpdate, onSave, saveButtonLabel }) => (
  <Box display="flex" alignItems="center" flexWrap="wrap" gap={1.5}>
    <UpdateOfferButton onUpdate={onUpdate} />
    <SaveButton label={saveButtonLabel} onSave={onSave} />
  </Box>
);

export default OfferSaveActions;
